import { render, staticRenderFns } from "./SolanRubricsTableRow.vue?vue&type=template&id=6380869e&scoped=true&"
import script from "./SolanRubricsTableRow.vue?vue&type=script&lang=ts&"
export * from "./SolanRubricsTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./SolanRubricsTableRow.vue?vue&type=style&index=0&id=6380869e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380869e",
  null
  
)

export default component.exports